<template>
  <vb-den-vt-index
    :statusByVT="VB_INCOMING_DOC.STATUS_VANTHU.DA_TIEP_NHAN"
    @viewDetail="viewDetail"
  ></vb-den-vt-index>
</template>
<script>
  import VbDenVtIndex from "./vbDenVTIndex";
  import constants from "../../constants";

  export default {
    components: {VbDenVtIndex},
    data() {
      return {
        VB_INCOMING_DOC: constants.VB_INCOMING_DOC
      };
    },
    methods: {
      viewDetail(event) {
        let item = event.doc;
        this.$router.push({
          name: "vbDenDaTiepNhanDetail",
          params: {id: item.id},
          query: this.$route.query
        });
      },
    }
  };
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenDaTiepNhanIndex.vue